import { ToolkitIcon } from '@airship-platform/jam-web/icons';
import Button from '@mui/material/Button';
import { Link } from 'react-router';
import { useAppointmentProposals } from '../../../data-access/appointmentProposals';
import ROUTE_PATHS from '../../../routes/paths';

const ProposalNavigationButton: React.FC = () => {
  const { currentProposal } = useAppointmentProposals();

  if (!currentProposal) {
    return null;
  }

  return (
    <Button
      component={Link}
      startIcon={<ToolkitIcon />}
      to={ROUTE_PATHS.APPOINTMENT_PATH({
        appointmentId: currentProposal.appointmentId,
        appointmentProposalId: currentProposal.appointmentProposalId,
        path: 'service-menu',
      })}
      color="softGold"
    >
      Toolkit
    </Button>
  );
};

export default ProposalNavigationButton;
